module.exports = __webpack_public_path__ + "static/media/logo_line.06c0c177.avif";